 var sharedFilters = angular.module('sharedFilters',[]);
 sharedFilters.filter('convertdate', function(dateFilter) {
    return function(input) {
        var input = input.replace(/-/g,'/');
        var currentDate = new Date().getTime();
        var postDate = input;
        var difference = Math.abs(currentDate - Date.parse(input));
        //console.log("currentDate",currentDate,"Date.parse(input)",Date.parse(input),input );
        input = Math.ceil(difference / (1000 * 3600));
        var output = input + ' hours ago'
        // if (input > 24) {
        //     input = Math.ceil(difference / (1000 * 3600 * 24));
        //     output = input + ' days ago';
        // }
        if (input > 24) {
            output = Date.parse(postDate);
            output = dateFilter(output);
        }
        return output;
    }
});
sharedFilters.filter('setwidth', function() {
    return function(input,width) {
        if (input) {
            var input = input.replace('%%', width);
        }
        return input;
    }
});
sharedFilters.filter('statusClass', function() {
    return function(input) {
        if (input) {
            var input = input.replace(/ /g, '_');
        }
        return input;
    }
});
sharedFilters.filter('addquotes', function() {
    return function(input,width) {
      var input = "'"+input+"'";
      return input;
    }
});
sharedFilters.filter('removeSpace', function() {
    return function(input,width) {
        if (input) {
            var input = input.replace(/ /g, '');
        }
        return input;
    }
});
sharedFilters.filter('removeDash', function() {
    return function(input) {
        if (input) {
            var input = input.replace(/_/g, ' ');
        }
        return input;
    }
});
sharedFilters.filter('datemonth', function() {
    return function(input,leads) {
      if (!input.match(/\d+/g)) {
        return input;
      } else if (input) { 
          if (leads != 'dateRange' && leads != 'oldQuote') {
              input = input.split(' ');
              time = input[1].toString();
              input = input[0].toString();
              input = input.split('-');
              month = input[1];
          }
          else {
            input = input.split('-');
            month = input[1];
          }
          switch(month) {
            case "01":
              month = 'Jan';
              break;
            case "02":
              month = 'Feb';
              break;
            case "03":
              month = 'Mar';
              break;
            case "04":
              month = 'Apr';
              break;
            case "05":
              month = 'May';
              break;
            case "06":
              month = 'Jun';
              break;
            case "07":
              month = 'Jul';
              break;
            case "08":
              month = 'Aug';
              break;
            case "09":
              month = 'Sept';
              break;
            case "10":
              month = 'Oct';
              break;
            case "11":
              month = 'Nov';
              break;
            case "12":
              month = 'Dec';
              break;

          }
          if (leads == 'oldQuote') {
            input = input[2]+' '+month+' '+input[0];
          }
          if(!leads || leads == 'dateRange') {
            input = input[2] + '-'+ month;
          }
          if(leads && leads != 'dateRange' && leads != 'oldQuote') {
            time = time.split(':'); // convert to array

            // fetch
            var hours = Number(time[0]);
            var minutes = Number(time[1]);
            var seconds = Number(time[2]);

            // calculate
            var timeValue = "" + ((hours >12) ? hours - 12 : hours);  // get hours
            timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
            //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
            timeValue += (hours >= 12) ? " PM" : " AM";  // get AM/PM
            if (leads == 'date') {
              input = input[2] + ' ' + month + ' ' + input[0];
            } else {
              input = timeValue + ' , ' + input[2] + ' ' + month + ' ' + input[0];
            }
          }

        }
        return input;
    }
});
sharedFilters.filter('lengthObject',function() {
    return function(input) {
        input = Object.keys(input).length;
        return input;
    }
});
sharedFilters.filter('truncate',function() {
    return function(input) {
        if(input && input.length> 0) {
            output = input.substr(0,12);
            if(input.length > 12) {
                return output + '..';
            } else {
                return input;
            }
        }
    }
});
sharedFilters.filter('trcate',function() {
    return function(input,index) {
        if(input && input.length> 0) {
            output = input.substr(0,index);
            if(input.length > index) {
                return output + '..';
            } else {
                return input;
            }
        }
    }
});
sharedFilters.filter('trncate',function() {
    return function(input) {
        if(input && input.length> 0) {
            output = input.substr(0,20);
            if(input.length > 20) {
                return output + '..';
            } else {
                return input;
            }
        }
    }
});

sharedFilters.filter('noOfPeople',function() {
  return function(input,people) {
    input = input.filter(function(value) {
      return (Number(value.floating_capacity) >= people);
    })
    return input;
  }
});

sharedFilters.filter('showBanquet',function() {
  return function(input, banquet) {
    if(banquet == 'all') {
      return input 
    } else  {
      if (input) {
        input = input.slice(0,banquet);
      }
      return input;
    }
  }
})

sharedFilters.filter('nulltozero',function() {
    return function(input,leads) {
        if(leads == 'leads') {
          if(!input) {
            input = '      - ';
            return input;
          } else {
            return input;
          }
        } else if(leads == 'reply') {
          input = Number(input);
          if(!input) {
            input = 'N';
            return input;
          } else {
            input = 'Y'
            return input;
          }
        } else {
          if(!input) {
              input = 0;
              return input;
          } else {
              return input;
          }
        }
    }
});

sharedFilters.filter('funcdate', function() {
  return function(input) {
    input = new Date(input);
    return input;
  }
})

sharedFilters.filter('capitalize', function() {
    return function(input) {
      return (!!input) ? (input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()).replace(/%20/g," ") : '';
    }
});
sharedFilters.filter('capitalizec', function() {
    return function(input) {
      return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase().replace('-'," ");
    }
});
sharedFilters.filter('convertString', function() {
    return function(input) {
      return input.toString();
    }
});
sharedFilters.filter('formatDate', function() {
    return function(input) {
      var output = input.split('-');
      var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";
      var finalDate = month[output[1]-1]+' '+output[2].split(' ')[0]+','+output[0]
      return finalDate;
    }
});


sharedFilters.filter('range', function() {
  return function(input, total) {
    total = parseInt(total);
    for (var i=0; i<total; i++)
      input.push(i);
    return input;
  };
});
sharedFilters.filter('rounded', function() {
  return function(input) {

    if(input != '0') {
      var number = input;
      var rounded = Math.round( number * 10 ) / 10;
      var input = rounded.toFixed(1);
    }
    return input;
  };
});
sharedFilters.filter('halfRange', function() {
  return function(input, total) {
    ceilValue = Math.ceil(total);
    floorValue = Math.floor(total);
    total = ceilValue - floorValue;
    for (var i=0; i<total; i++)
      input.push(i);
    return input;
  };
});
sharedFilters.filter('checkhttp',function(){
  return function(input) {
    var pattern = /^((http|https|ftp):\/\/)/;
    if(input && !pattern.test(input)) {
      input = 'http://' + input;
    }
    return input;
  }
});

sharedFilters.filter('nanCheck',function() {
  return function(input,limit) {
  }
});

sharedFilters.filter('faqQues',function() {
  return function(input) {
    input = input.replace('Q:','');
    if(input.indexOf('-') == 0) {
      input = input.replace('-','');
    };
    return input;
  }
});

sharedFilters.filter('shakahari',function() {
  return function(input,type) {
    return input ;
  }
})

sharedFilters.filter('customFilter',function() {
  return function(items, searchText,custom) {
    var filtered = [];
    if (searchText == '' || typeof searchText == 'undefined') 
    {
      return items; 
    }
     angular.forEach(items, function(item) {
       if( item.name.toLowerCase().indexOf(searchText.toLowerCase()) >= 0 ) {
          filtered.push(item);
        }
        var letters = item.name.split('');
        $(letters).each(function(letter) {
            if (letter === searchText) { // matches single letter, e.g. 'E'
                filtered.push(item);
            }
        });
        // code to match letter fragments, e.g. 'lan'
    });
    if (custom == 'allowPh') {
       angular.forEach(items, function(item) {
        if( item.phone != null){
          item.phone = item.phone.toString();
          searchText = searchText.toString();
         if( item.phone.indexOf(searchText) >= 0 ) {
            filtered.push(item);
          }
          var letters = item.phone;
          $(letters).each(function(letter) {
              if (letter === searchText) { // matches single letter, e.g. 'E'
                  filtered.push(item);
              }
          });
        }
        // code to match letter fragments, e.g. 'lan'
      });
    }
    return filtered;
};
});

 sharedFilters.filter('convertMonth', function() {
  return function(input) {
    switch(input) {
      case 0:
        input = 'January';
        break;
      case 1:
        input = 'February';
        break;
      case 2:
        input = 'March';
        break;
      case 3:
        input = 'April';
        break;
      case 4:
        input = 'May';
        break;
      case 5:
        input = 'June';
        break;
      case 6:
        input = 'July';
        break;
      case 7:
        input = 'August';
        break;
      case 8:
        input = 'September';
        break;
      case 9:
        input = 'October';
        break;
      case 10:
        input = 'November';
        break;
      case 11:
        input = 'December';
        break;
      }
    return input;
  }
});

 sharedFilters.filter('timeConvert', function() {
   return function(input) {
     if(input == undefined || input == "") {
       return "NA"
     }
     var timeString = '';
     var timeArray = input.split('-').map(function(x) { return x.split(':') });
     if(timeArray[0][0] > 12){
       timeString = (timeArray[0][0] - 12) + ':' + timeArray[0][1];
     } else {
       timeString = timeArray[0][0] + ':' + timeArray[0][1];
     } 
     
     if(timeArray[1][0] > 12){
       timeString = timeString + ' - ' + (timeArray[1][0] - 12) + ':' + timeArray[1][1];
     } else {
       timeString = timeString + ' - ' +timeArray[1][0] + ':' + timeArray[1][1];
     }
     
     return timeString;
    //  var timeString = input;
    //  var dd = "AM";
    //  var hh = timeString.split(':')[0];
    //  var m = timeString.split(':')[1];
    //  var h = hh;
    //  if (h >= 12) {
    //    h = hh-12;
    //    dd = "PM";
    //  }
    //  if (h == 0) {
    //    h = 12;
    //  }
    //  return h+":"+m+" "+dd;
   }
 });

sharedFilters.filter('trustedAudioUrl', function($sce) {
    return function(path) {
      if (path) {
        return $sce.trustAsResourceUrl(path);
      }
    };
})

sharedFilters.filter('removeNcr', function() {
    return function(input) {
      var finalString = input;
      if(input && finalString.indexOf('NCR') != -1) {
        var startIndex = finalString.indexOf('NCR') - 1;
        var endIndex = finalString.indexOf('NCR') + 3;
        return finalString = finalString.replace(finalString.substring(startIndex, endIndex), "");
      } else if(input && finalString.indexOf('NCR') == -1) {
        return finalString;
      }
    }
});

sharedFilters.filter('slice', function($timeout) {
  return function(arr, start, end) {
    if (!end) {
      return (arr || []).slice(start);
    }
    return (arr || []).slice(start, end);
  };
});

sharedFilters.filter('capitalizeFirstLetter', function() {
  return function(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  };
});

sharedFilters.filter('removeUnderScore',function() {
  return function(input) {
    return input.replace(/_/g,' ');
  }

});

sharedFilters.filter('spliceString',function() {
  return function(input,char) {
    input = input.replace(char,'');
    return input;
  }
})

sharedFilters.filter('spliceLast',function() {
  return function(input) {
    input = input.substring(0,input.length -1);
    return input;
  }
})